module.exports = __webpack_public_path__ + "static/2020-in-review-e004ad3d6d41c3461845366ecffa4baa.png";